export default "__VITE_ASSET__GMCOFGqu__"